export const MAX_SIZE_BYTES = 800 * 1024;
export const PDF_ALLOWED_EXTENSIONS = ['application/pdf'];
